import React from 'react';
import PropTypes from 'prop-types';
import { isFeatureOn } from './features';

const FeatureFlag = ({ flag, children, ...rest }) => {
	if (isFeatureOn(flag)) {
		if (rest) {
			return React.Children.map(children, child => {
				if (React.isValidElement(child)) {
					return React.cloneElement(child, rest);
				}
				return child;
			});
		}
		return children;
	}
	return null;
};

FeatureFlag.propTypes = {
	flag: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	rest: PropTypes.arrayOf(PropTypes.any)
};

export default FeatureFlag;
